<template>
  
  <v-row>
      <!-- <div>
        <mm-toggle v-model="isDrawerOpen" />
        Toggle
      </div> -->
      <!-- <div class="d-flex">
        <mm-drawer v-model="isDrawerOpen" 
        value
      collapsable
      :minimizable="false"
      :minimized="false"
      fixed
      :full="false"
      position="left"
      >
          <NavigationBar class="navigationBar" :workflows="workflowTitles" @workflow-selected="setWorkflow" />
        </mm-drawer>
      </div>
      <div :class="{'DrawerOpen': isDrawerOpen, 'p-x-8':!isDrawerOpen}"> -->
        <!-- <v-row>
          <b>To change data of the workflow for this browser session. please select new file to upload</b>
    <input type="file" @change="handleFileUpload" accept=".json" />
  </v-row> -->
  <v-row>
  <div class="mb-2">
    <b>To change data of the workflow for this browser session, please select a new file to upload:</b>
  </div>
  <div>
    <input type="file" @change="handleFileUpload" accept=".json" />
  </div>
</v-row>
  <v-row v-if="selectedWorkflow">
    <WorkFlow :workflow="selectedWorkflow" />
  </v-row>
  <v-row v-else>
    <p>Please upload a workflow file.</p>
  </v-row>

    <!-- </div> -->
  </v-row>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
// import NavigationBar from '@/components/Navigation-Bar.vue';
import WorkFlow from '@/components/Work-Flow.vue';

export default {
  data() {
    return {
      isDrawerOpen: false
    };
  },
  components: {
    // NavigationBar,
    WorkFlow
  },
  computed: {
    ...mapGetters(['getWorkflows', 'getWorkflowTitles', 'getSelectedWorkflow']),
    // workflowTitles() {
    //   return this.getWorkflowTitles; // Pass workflow titles to NavigationBar
    // },
 
    selectedWorkflow() {
      return this.getSelectedWorkflow; // Pass selected workflow to WorkFlow
    }
  },
  methods: {
    ...mapActions(['fetchWorkflows', 'selectWorkflow']),
    // setWorkflow(workflowTitle) {
    //   this.selectWorkflow(workflowTitle);
    // }
    handleFileUpload(event) {
      const file = event.target.files[0];

      if (file) {
        const reader = new FileReader();

        reader.readAsText(file);
        reader.onload = () => {
          try {
            const parsedData = JSON.parse(reader.result);
            this.selectWorkflow(parsedData); // Store workflow in Vuex
          } catch (error) {
            console.error("Error parsing JSON:", error);
          }
        };

        reader.onerror = () => {
          console.error("Error reading file:", reader.error);
        };
      }
    }
  },
  mounted() {
    this.fetchWorkflows();
  }
};
</script>

<style scoped>
.DrawerOpen{
  margin-left: 25%;
}
.col,
.col-3,
.col-9 {
  padding: 0 !important;
}

.row {
  margin: 0;
}
</style>
